import intl from 'react-intl-universal';
import { deleteRequest } from 'state/normalized/requests/requestsSlice';
import { useDispatch } from 'react-redux';
import { Modal } from '@getsynapse/design-system';
import { showNotification } from 'state/SnackbarNotification/SnackbarNotificationSlice';

type DeleteRequestModalProps = {
  isOpen: boolean;
  requestId: string;
  requestNumber: string;
  closeModal: () => void;
};

const DeleteRequestModal = ({
  isOpen,
  requestId,
  requestNumber,
  closeModal,
}: DeleteRequestModalProps) => {
  const dispatch = useDispatch();

  const handleDeleteRequest = async () => {
    closeModal();
    try {
      await dispatch(deleteRequest(requestId));
      dispatch(
        showNotification({
          notificationVariant: 'success',
          notificationTitle: intl.get(
            'REQUEST_PAGE.TOP_BAR.DELETE_REQUEST_MODAL.SUCCESS_MESSAGE'
          ),
        })
      );
    } catch {
      dispatch(
        showNotification({
          notificationVariant: 'error',
          notificationTitle: intl.get(
            'REQUEST_PAGE.TOP_BAR.DELETE_REQUEST_MODAL.ERROR_MESSAGE_TITLE'
          ),
          notificationMessage: intl.get(
            'REQUEST_PAGE.TOP_BAR.DELETE_REQUEST_MODAL.ERROR_MESSAGE_BODY'
          ),
        })
      );
    }
  };

  return (
    <Modal
      aria-label={intl.get('REQUESTS_LIST_PAGE.MODAL.DELETE_REQUEST.TITLE')}
      title={intl.get('REQUESTS_LIST_PAGE.MODAL.DELETE_REQUEST.TITLE')}
      data-testid='delete-request-modal'
      isOpen={isOpen}
      closeModal={() => {}}
      size='medium'
      actionButtons={[
        {
          children: intl.get(
            'REQUESTS_LIST_PAGE.MODAL.DELETE_REQUEST.DELETE_BUTTON'
          ),
          color: 'danger',
          onClick: handleDeleteRequest,
          'data-testid': 'delete-request-button',
        },
        {
          children: intl.get(
            'REQUESTS_LIST_PAGE.MODAL.DELETE_REQUEST.CANCEL_BUTTON'
          ),
          variant: 'tertiary',
          onClick: closeModal,
        },
      ]}
    >
      {intl.get('REQUESTS_LIST_PAGE.MODAL.DELETE_REQUEST.BODY', {
        requestNo: requestNumber,
      })}
    </Modal>
  );
};

export default DeleteRequestModal;
